import type { InitialType } from 'use-url-search-params';

import {
  redirectEWalletQuery,
  redirectFpxQuery,
  redirectOnlineBankingQuery,
  redirectPayPalQuery,
} from './constants';

export const checkIsPaymentsReturnUrl = (params: InitialType) =>
  [
    redirectOnlineBankingQuery.value,
    redirectEWalletQuery.value,
    redirectPayPalQuery.value,
    redirectFpxQuery.value,
  ].some((value) => params.payments_return === value);
